import { render } from "./Swiper.vue?vue&type=template&id=7e3bce5c&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=7e3bce5c&lang=less&scoped=true"

import exportComponent from "D:\\case\\追溯平台\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3bce5c"]])

export default __exports__